import React from 'react';
import s from './ButtonsCommonStyles.module.css';
import styles from './ButtonEffects.module.css';
import {useRippleEffect} from '../../hooks/useRippleEffect';

type Props = {
	text: string;
	onClick?: () => void;
	type?: 'submit' | 'button' | 'reset' | undefined;
	disabled?: boolean;
	loading?: boolean;
	icon?: React.ReactNode;
};

const VeryLightGreenButton: React.FC<Props> = ({
	text,
	onClick,
	type,
	disabled,
	loading,
	icon,
}) => {
	const {ripples, createRipple} = useRippleEffect();

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (disabled || loading) return;
		
		createRipple(e);
		
		// Вызываем оригинальный onClick
		if (onClick) onClick();
	};

	return (
		<button
			disabled={disabled || loading}
			type={type}
			className={`${s.button} btn-main ${styles.veryLightGreenButton} ${loading ? styles.loading : ''}`}
			onClick={handleClick}
		>
			{icon && <span className={styles.iconContainer}>{icon}</span>}
			{loading ? 'Завантаження...' : text}
			{ripples.map(ripple => (
				<span
					key={ripple.id}
					className={styles.ripple}
					style={{
						left: ripple.x - 10,
						top: ripple.y - 10,
					}}
				/>
			))}
		</button>
	);
};

export default VeryLightGreenButton;
